export default "__VITE_ASSET__6q3HJ_8I__"